import React, { useState } from "react";
import { Container } from "react-bootstrap";
import img1 from "../../assets/Images/Blogs/Gemini_Generated_Image_610kpx610kpx610k.jpg";
import img2 from "../../assets/Images/Blogs/Gemini_Generated_Image_jjsc6ajjsc6ajjsc.jpg";
import img3 from "../../assets/Images/Blogs/Gemini_Generated_Image_1b1m6l1b1m6l1b1m.jpg";
import img4 from "../../assets/Images/Blogs/Gemini_Generated_Image_nxrdcgnxrdcgnxrd.jpg";
import img5 from "../../assets/Images/Blogs/Gemini_Generated_Image_9flvsg9flvsg9flv.jpg";
import img6 from "../../assets/Images/Blogs/Gemini_Generated_Image_r35v9mr35v9mr35v.jpg";

import { useIsMobile } from "../../utils/responsive";

export default function Section5() {
  const [hoveredImage, setHoveredImage] = useState(null);

  const isMobile = useIsMobile();

  const handleImageHover = (index) => {
    setHoveredImage(index);
  };

  const sectionData = [
    {
      title: "1. ARCHITECTURAL FEATURES",
      content: [
        "High Ceilings & Crown Molding – Adds a sense of grandeur.",
        "Paneled Walls & Wainscoting – Often in wood or painted in classic shades.",
        "Arched Doorways & Decorative Columns – Creates a refined, historic feel.",
        "Large Bay Windows & Stained Glass – Enhances natural light with an old-world charm.",
        "Wooden or Marble Fireplaces – A focal point in living areas.",
      ],
      image: img1,
      imageIndex: 1,
    },
    {
      title: "2. COLOR PALETTE",
      content: [
        "Rich, Deep Hues – Burgundy, forest green, navy blue, and gold.",
        "Muted Pastels – Soft creams, dusty roses, and sage greens for a subtle touch.",
        "Dark Wood Accents – Mahogany, walnut, or oak for furniture and flooring.",
      ],
      image: img2,
      imageIndex: 2,
    },
    {
      title: "3. FLOORING",
      content: [
        "Hardwood Flooring – Dark-stained oak or mahogany.",
        "Patterned Tiles – Intricate Victorian designs in hallways and bathrooms.",
        "Persian or Oriental Rugs – Adds warmth and texture.",
      ],
      image: img3,
      imageIndex: 3,
    },
    {
      title: "4. FURNITURE & DECOR",
      content: [
        "Ornate Wooden Furniture – Hand-carved pieces with curved legs and intricate detailing.",
        "Victorian Sofas & Chaise Lounges – Upholstered in velvet or brocade.",
        "Antique Chandeliers & Wall Sconces – Crystal, brass, or wrought iron lighting.",
        "Heavy Drapes & Lace Curtains – Layered fabrics in rich textures.",
        "Classic Wall Art & Gilded Mirrors – Portraits, floral paintings, and oversized mirrors.",
      ],
      image: img4,
      imageIndex: 4,
    },
    {
      title: "5. ACCESSORIES & STYLING",
      content: [
        "Porcelain & China Displays – Vintage dinnerware and teacups.",
        "Grand Bookshelves & Writing Desks – Creating a refined study or library.",
        "Victorian Floral Arrangements – Roses, lilies, and ivy in decorative vases.",
        "Decorative Ceiling Medallions – Enhancing chandelier fixtures.",
      ],
      image: img5,
      imageIndex: 5,
    },
    {
      title: "6. OUTDOOR & EXTERIOR DESIGN",
      content: [
        "Wraparound Porches – With wooden railings and rocking chairs.",
        "Intricate Ironwork – On gates, fences, and balconies.",
        "Classic White or Pastel Facade – Often with contrasting shutters.",
        "Landscaped Gardens – Featuring fountains, roses, and manicured hedges.",
      ],
      image: img6,
      imageIndex: 6,
    },
  ];

  return (
    <Container fluid className="p-0">
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}
        <div
          style={{
            width: isMobile ? "100%" : "60%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            borderRight: isMobile ? "none" : "1px solid black",
            // borderLeft: "1px solid black",
          }}
        >
          <div
            style={{
              padding: "20px 40px",
            }}
          >
            <h3 className="heading-sm m-0">
              KEY ELEMENTS OF VICTORIAN COLONIAL DESIGN
            </h3>
          </div>
        </div>
        {!isMobile && (
          <div
            style={{
              width: "30%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "50%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "100%",
                height: "50%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
          </div>
        )}
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
      {/* --------------------------------------------------------------------------------------- */}
      {!isMobile && (
        <>
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: isMobile ? "20px 40px" : "40px 40px",
                }}
              >
                <h3 className="heading-sm m-0">1. ARCHITECTURAL FEATURES</h3>
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: isMobile ? "20px 40px" : "40px 40px",
                }}
              >
                <h3 className="heading-sm m-0">2. COLOR PALETTE</h3>
              </div>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: isMobile ? "20px 40px" : "40px 40px",
                }}
              >
                <ul
                  style={{
                    fontFamily: "BodoniModa_18pt",
                    fontSize: "24px",
                  }}
                >
                  <li>
                    High Ceilings & Crown Molding – Adds a sense of grandeur.
                  </li>
                  <li>
                    Paneled Walls & Wainscoting – Often in wood or painted in
                    classic shades.
                  </li>
                  <li>
                    Arched Doorways & Decorative Columns – Creates a refined,
                    historic feel.
                  </li>
                  <li>
                    Large Bay Windows & Stained Glass – Enhances natural light
                    with an old-world charm.
                  </li>
                  <li>
                    Wooden or Marble Fireplaces – A focal point in living areas.
                  </li>
                </ul>
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: isMobile ? "20px 40px" : "40px 40px",
                }}
              >
                <ul
                  style={{
                    fontFamily: "BodoniModa_18pt",
                    fontSize: "24px",
                  }}
                >
                  <li>
                    Rich, Deep Hues – Burgundy, forest green, navy blue, and
                    gold.
                  </li>
                  <li>
                    Muted Pastels – Soft creams, dusty roses, and sage greens
                    for a subtle touch.
                  </li>
                  <li>
                    Dark Wood Accents – Mahogany, walnut, or oak for furniture
                    and flooring.
                  </li>
                </ul>
              </div>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                overflow: "hidden",
              }}
            >
              <div
                className="image-container"
                style={{
                  height: "100%",
                  minHeight: "400px",
                  display: "flex",
                  flexDirection: "row",
                  gap: "0",
                  transition: "all 0.5s ease",
                }}
                onMouseEnter={() => handleImageHover(1)}
                onMouseLeave={() => handleImageHover(null)}
              >
                <img
                  src={img1}
                  alt="Profile 1"
                  className="image-cover-full-responsive"
                  style={{
                    transition: "all 0.5s ease",
                    transform: hoveredImage === 1 ? "scale(1.05)" : "scale(1)",
                    filter:
                      hoveredImage === 1 ? "brightness(1.05)" : "brightness(1)",
                  }}
                />
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                overflow: "hidden",
              }}
            >
              <div
                className="image-container"
                style={{
                  height: "100%",
                  minHeight: "400px",
                  display: "flex",
                  flexDirection: "row",
                  gap: "0",
                  transition: "all 0.5s ease",
                }}
                onMouseEnter={() => handleImageHover(2)}
                onMouseLeave={() => handleImageHover(null)}
              >
                <img
                  src={img2}
                  alt="Profile 1"
                  className="image-cover-full-responsive"
                  style={{
                    transition: "all 0.5s ease",
                    transform: hoveredImage === 2 ? "scale(1.05)" : "scale(1)",
                    filter:
                      hoveredImage === 2 ? "brightness(1.05)" : "brightness(1)",
                  }}
                />
              </div>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
          {/* --------------------------------------------------------------------------------------- */}
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: isMobile ? "20px 40px" : "40px 40px",
                }}
              >
                <h3 className="heading-sm m-0">3. FLOORING</h3>
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: isMobile ? "20px 40px" : "40px 40px",
                }}
              >
                <h3 className="heading-sm m-0">4. FURNITURE & DECOR</h3>
              </div>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: isMobile ? "20px 40px" : "40px 40px",
                }}
              >
                <ul
                  style={{
                    fontFamily: "BodoniModa_18pt",
                    fontSize: "24px",
                  }}
                >
                  <li>Hardwood Flooring – Dark-stained oak or mahogany.</li>
                  <li>
                    Patterned Tiles – Intricate Victorian designs in hallways
                    and bathrooms.
                  </li>
                  <li>Persian or Oriental Rugs – Adds warmth and texture.</li>
                </ul>
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: isMobile ? "20px 40px" : "40px 40px",
                }}
              >
                <ul
                  style={{
                    fontFamily: "BodoniModa_18pt",
                    fontSize: "24px",
                  }}
                >
                  <li>
                    Ornate Wooden Furniture – Hand-carved pieces with curved
                    legs and intricate detailing.
                  </li>
                  <li>
                    Victorian Sofas & Chaise Lounges – Upholstered in velvet or
                    brocade.
                  </li>
                  <li>
                    Antique Chandeliers & Wall Sconces – Crystal, brass, or
                    wrought iron lighting.
                  </li>
                  <li>
                    Heavy Drapes & Lace Curtains – Layered fabrics in rich
                    textures.
                  </li>
                  <li>
                    Classic Wall Art & Gilded Mirrors – Portraits, floral
                    paintings, and oversized mirrors.
                  </li>
                </ul>
              </div>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                overflow: "hidden",
              }}
            >
              <div
                className="image-container"
                style={{
                  height: "100%",
                  minHeight: "400px",
                  display: "flex",
                  flexDirection: "row",
                  gap: "0",
                  transition: "all 0.5s ease",
                }}
                onMouseEnter={() => handleImageHover(3)}
                onMouseLeave={() => handleImageHover(null)}
              >
                <img
                  src={img3}
                  alt="Profile 1"
                  className="image-cover-full-responsive"
                  style={{
                    transition: "all 0.5s ease",
                    transform: hoveredImage === 3 ? "scale(1.05)" : "scale(1)",
                    filter:
                      hoveredImage === 3 ? "brightness(1.05)" : "brightness(1)",
                  }}
                />
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                overflow: "hidden",
              }}
            >
              <div
                className="image-container"
                style={{
                  height: "100%",
                  minHeight: "400px",
                  display: "flex",
                  flexDirection: "row",
                  gap: "0",
                  transition: "all 0.5s ease",
                }}
                onMouseEnter={() => handleImageHover(4)}
                onMouseLeave={() => handleImageHover(null)}
              >
                <img
                  src={img4}
                  alt="Profile 1"
                  className="image-cover-full-responsive"
                  style={{
                    transition: "all 0.5s ease",
                    transform: hoveredImage === 4 ? "scale(1.05)" : "scale(1)",
                    filter:
                      hoveredImage === 4 ? "brightness(1.05)" : "brightness(1)",
                  }}
                />
              </div>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
          {/* --------------------------------------------------------------------------------------- */}
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: isMobile ? "20px 40px" : "40px 40px",
                }}
              >
                <h3 className="heading-sm m-0">5. ACCESSORIES & STYLING</h3>
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: isMobile ? "20px 40px" : "40px 40px",
                }}
              >
                <h3 className="heading-sm m-0">6. OUTDOOR & EXTERIOR DESIGN</h3>
              </div>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: isMobile ? "20px 40px" : "40px 40px",
                }}
              >
                <ul
                  style={{
                    fontFamily: "BodoniModa_18pt",
                    fontSize: "24px",
                  }}
                >
                  <li>
                    Porcelain & China Displays – Vintage dinnerware and teacups.
                  </li>
                  <li>
                    Grand Bookshelves & Writing Desks – Creating a refined study
                    or library.
                  </li>
                  <li>
                    Victorian Floral Arrangements – Roses, lilies, and ivy in
                    decorative vases.
                  </li>
                  <li>
                    Decorative Ceiling Medallions – Enhancing chandelier
                    fixtures.
                  </li>
                </ul>
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <ul
                style={{
                  fontFamily: "BodoniModa_18pt",
                  fontSize: "24px",
                }}
                className="px-5 p-4"
              >
                <li>
                  Wraparound Porches – With wooden railings and rocking chairs.
                </li>
                <li>Intricate Ironwork – On gates, fences, and balconies.</li>
                <li>
                  Classic White or Pastel Facade – Often with contrasting
                  shutters.
                </li>
                <li>
                  Landscaped Gardens – Featuring fountains, roses, and manicured
                  hedges.
                </li>
              </ul>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                overflow: "hidden",
              }}
            >
              <div
                className="image-container"
                style={{
                  height: "100%",
                  minHeight: "400px",
                  display: "flex",
                  flexDirection: "row",
                  gap: "0",
                  transition: "all 0.5s ease",
                }}
                onMouseEnter={() => handleImageHover(5)}
                onMouseLeave={() => handleImageHover(null)}
              >
                <img
                  src={img5}
                  alt="Profile 1"
                  className="image-cover-full-responsive"
                  style={{
                    transition: "all 0.5s ease",
                    transform: hoveredImage === 5 ? "scale(1.05)" : "scale(1)",
                    filter:
                      hoveredImage === 5 ? "brightness(1.05)" : "brightness(1)",
                  }}
                />
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",

                overflow: "hidden",
              }}
            >
              <div
                className="image-container"
                style={{
                  height: "100%",
                  minHeight: "400px",
                  display: "flex",
                  flexDirection: "row",
                  gap: "0",
                  transition: "all 0.5s ease",
                  borderBottom: "1px solid black",
                }}
                onMouseEnter={() => handleImageHover(6)}
                onMouseLeave={() => handleImageHover(null)}
              >
                <img
                  src={img6}
                  alt="Profile 1"
                  className="image-cover-full-responsive"
                  style={{
                    transition: "all 0.5s ease",
                    transform: hoveredImage === 6 ? "scale(1.05)" : "scale(1)",
                    filter:
                      hoveredImage === 6 ? "brightness(1.05)" : "brightness(1)",
                  }}
                />
              </div>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
        </>
      )}
      {isMobile &&
        sectionData.map((section, index) => (
          <div key={index}>
            <div
              style={{
                padding: isMobile ? "20px 40px" : "40px 40px",
                borderBottom: "1px solid black",
              }}
            >
              <h3 className="heading-sm m-0">{section.title}</h3>
            </div>
            <div
              style={{
                padding: isMobile ? "20px 40px" : "40px 40px",
                borderBottom: "1px solid black",
              }}
            >
              <ul>
                {section.content.map((item, itemIndex) => (
                  <li key={itemIndex}>{item}</li>
                ))}
              </ul>
            </div>
            <div
              className="image-container"
              style={{
                height: "100%",
                minHeight: "400px",
                display: "flex",
                flexDirection: "row",
                gap: "0",
                transition: "all 0.5s ease",
                borderBottom: "1px solid black",
              }}
              onMouseEnter={() => handleImageHover(section.imageIndex)}
              onMouseLeave={() => handleImageHover(null)}
            >
              <img
                src={section.image}
                alt="Profile 1"
                className="image-cover-full-responsive"
                style={{
                  transition: "all 0.5s ease",
                  transform:
                    hoveredImage === section.imageIndex
                      ? "scale(1.05)"
                      : "scale(1)",
                  filter:
                    hoveredImage === section.imageIndex
                      ? "brightness(1.05)"
                      : "brightness(1)",
                }}
              />
            </div>
          </div>
        ))}
      {/* --------------------------------------------------------------------------------------- */}
      {!isMobile && (
        <div className="d-flex justify-content-center">
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
          <div
            style={{
              width: "90%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          >
            <h2
              className="m-0 p-4 px-5  text-uppercase"
              style={{
                fontSize: "48px",
                fontFamily: "BodoniModa_18pt",
                visibility: "hidden",
              }}
            >
              KEY ELEMENTS OF VICTORIAN COLONIAL DESIGN
            </h2>
          </div>

          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        </div>
      )}
    </Container>
  );
}
